import { FC, KeyboardEvent, MouseEvent } from 'react';

import { VisuallyHidden } from '@purpur/library';
import { IconCloseCircle } from '@purpur/library/icon/close-circle';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';
import { useComponentId } from '@telialt/utils/src/hooks';

import { PLAN_CARD_TEST_ID } from '../constants';
import { PlanCardModel } from '../model';
import { ModalTriggerText, TextButtonWithIconStyled, TextWithIconStyled } from '../PlanCard.styles';

type Props = {
    children: string;
    isDisabled?: boolean;
    onClick?: (event: MouseEvent<HTMLAnchorElement> | KeyboardEvent<HTMLAnchorElement>) => void;
} & PlanCardModel.NegativeProp;

export const DetailsModalTriggerButton: FC<Props> = ({ onClick, children, isNegative, isDisabled }) => {
    const description = useComponentId('not-included-detail');
    const { t } = useTranslations();

    if (isDisabled) {
        return (
            <TextWithIconStyled
                $negative={isNegative}
                aria-describedby={description}
                data-test={PLAN_CARD_TEST_ID.DETAILS_ITEM}
            >
                <VisuallyHidden id={description}>{t['plans.aria_label.feature_not_included']}</VisuallyHidden>
                <IconCloseCircle size="sm" />
                {children}
            </TextWithIconStyled>
        );
    }

    return (
        <TextButtonWithIconStyled
            onClick={onClick}
            icon="check-circle"
            iconSize="sm"
            dataTest={PLAN_CARD_TEST_ID.DETAILS_ITEM}
            $negative={isNegative}
            negative={isNegative}
        >
            <ModalTriggerText $negative={isNegative}>{children}</ModalTriggerText>
        </TextButtonWithIconStyled>
    );
};
